interface Props {
  data: any;
}
import Image from "next/image";
import defaultImage from "image/image.svg";
import { DOCUMENT_URL } from "src/constants/constants";
import Link from "next/link";
import { dateFormatter } from "src/utils/helperFunctions";

const FeaturedList = ({ data }: Props) => {
  return (
    <div className="">
      {data.slice(1, data.length).map((eachFeatured: any, eachInd: number) => (
        <Link key={eachInd + 1 + ""} href={`/blog/${eachFeatured.slug}`}>
          <div className="flex gap-2 mb-4">
            <Image
              src={
                eachFeatured.main_image.document_name
                  ? `${DOCUMENT_URL}${eachFeatured.main_image.document_name}`
                  : defaultImage
              }
              className={`rounded`}
              alt="image"
              width={100}
              height={100}
            />
            <div className="m-0 text-sm dark:text-dark-text-primary">
              {eachFeatured.title} :{" "}
              <p className="m-0 mt-2 text-xs text-gray-500 dark:text-dark-text-secondary">
                <span className="pr-1">
                  {dateFormatter(new Date(eachFeatured.published_date), "m y")}{" "}
                </span>
                <span className="pl-1 border-l border-gray-500 dark:text-dark-text-secondary">
                  {eachFeatured.minute_read} min read
                </span>
              </p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default FeaturedList;
